import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { UnidadeNegocioPopulaModalComponent } from './popula';
import { UnidadeNegocioNomePipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        UnidadeNegocioPopulaModalComponent,

        UnidadeNegocioNomePipe
    ],
    exports: [
        UnidadeNegocioPopulaModalComponent,

        UnidadeNegocioNomePipe
    ],
    providers: [
        UnidadeNegocioNomePipe
    ]
})
export class UnidadeNegocioSharedModule { }
